var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datepicker',{ref:_vm.ref,attrs:{"id":_vm.id,"format":"yyyy-MM-dd","typeable":true,"open-date":_vm.openDate,"placeholder":"YYYY-MM-DD"},on:{"selected":_vm.dateSelected},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }